<template>
    <div class="footer">
       <footer class="proFooter">
            <img src="../../assets/img/logo.png" />
            <ul class="proConnect">
                <li>
                    <span>咨询热线：</span>
                    <label>021-51791688-5057</label>
                </li>
                <li>
                    <span>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</span>
                    <label>dingjj@digiwin.com</label>
                </li>
                <li>
                    <span>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</span>
                    <label>上海市静安区江场路1377弄1号楼</label>
                </li>
            </ul>
            <div class="proLink">
                <span>友情链接：</span>
                <ul>
                    <li><a href="https://www.digiwin.com/software/digiwinERP.html?utm_source=bdpz&utm_campain=biaoti" target="_blank">鼎捷数智</a></li>
                    <li><a href="https://market.digiwincloud.com.cn/" target="_blank">鼎捷云市场</a></li>
                    <li><a href="http://es-ygj.digiwincloud.com.cn/" target="_blank">鼎捷云管家</a></li>
                </ul>
                <div class="clear"></div>
            </div>
            <p>Copyright© 鼎捷数智股份有限公司. Copyright © Digiwin Datasys Co.,Ltd. All rights reserved.</p>
        </footer>
    </div>
</template>
<script>
  export default {
    name: 'Footer'
  }
</script>



// WEBPACK FOOTER //
// src/components/common/Footer.vue